// About.js
import React from 'react';
import MainLayout from '../../layout/MainLayout';
import AboutMe from './AboutMe';
import MyService from './MyService';
import Testimonials from './Testimonials';

function About() {
    return (
        <MainLayout>
            <AboutMe />
            <MyService />
            <Testimonials />
        </MainLayout>
    );
}

export default About;